(function() {
  'use strict';

  function initIndigoFable() {
    var isProductPage = !!document.querySelector('.product-information');
    if (!isProductPage) return;
    if (document.getElementById('artisan-journey')) return;

    var mainSection = document.querySelector('.product-information');
    var mainParent = mainSection ? mainSection.closest('.shopify-section') : null;
    var recommendations = document.querySelector('[class*="product-recommendations"]');
    var insertParent = mainParent ? mainParent.parentNode : null;
    var insertBeforeTarget = recommendations ? recommendations.closest('.shopify-section') : null;

    var customBlock = mainSection.querySelector('[id*="ProductMain-"]');

    /* ================================================
       BREADCRUMBS
       ================================================ */
    var productTitle = '';
    var titleEl = mainSection.querySelector('h1');
    if (titleEl) productTitle = titleEl.textContent.trim();

    var breadcrumbsEl = document.createElement('nav');
    breadcrumbsEl.className = 'if-breadcrumbs';
    breadcrumbsEl.innerHTML = [
      '<a href="/">Home</a>',
      '<span class="if-breadcrumbs__sep">/</span>',
      '<a href="/collections/all">Shop</a>',
      '<span class="if-breadcrumbs__sep">/</span>',
      '<span class="if-breadcrumbs__current">' + productTitle + '</span>'
    ].join('');

    var productDetailsBlock = mainSection.querySelector('[class*="_product-details"]') || mainSection.querySelector('[class*="product-details"]');
    if (productDetailsBlock) {
      productDetailsBlock.insertBefore(breadcrumbsEl, productDetailsBlock.firstChild);
    } else if (customBlock) {
      customBlock.parentNode.insertBefore(breadcrumbsEl, customBlock);
    }

    /* ================================================
       QUANTITY SELECTOR
       Inject before the ATC button form
       ================================================ */
    var productForm = mainSection.querySelector('.ai-product-form') || mainSection.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      var qtyWrap = document.createElement('div');
      qtyWrap.className = 'if-quantity-wrap';
      qtyWrap.innerHTML = [
        '<label class="if-quantity-label">Quantity</label>',
        '<div class="if-quantity-selector">',
        '  <button type="button" class="if-quantity-btn if-qty-minus" aria-label="Decrease quantity">',
        '    <svg viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/></svg>',
        '  </button>',
        '  <span class="if-quantity-val">1</span>',
        '  <button type="button" class="if-quantity-btn if-qty-plus" aria-label="Increase quantity">',
        '    <svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>',
        '  </button>',
        '</div>'
      ].join('');

      productForm.parentNode.insertBefore(qtyWrap, productForm);

      var qtyVal = qtyWrap.querySelector('.if-quantity-val');
      var qty = 1;

      qtyWrap.querySelector('.if-qty-minus').addEventListener('click', function() {
        if (qty > 1) { qty--; qtyVal.textContent = qty; }
      });
      qtyWrap.querySelector('.if-qty-plus').addEventListener('click', function() {
        qty++; qtyVal.textContent = qty;
      });
    }

    /* ================================================
       ADD SHOPPING BAG ICON TO ATC BUTTON
       ================================================ */
    var atcBtn = mainSection.querySelector('[class*="ai-product-details__btn--atc"]');
    if (atcBtn) {
      var btnText = atcBtn.textContent.trim();
      atcBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg><span>' + btnText + '</span>';
    }

    /* ================================================
       MOBILE STICKY ADD-TO-CART BAR
       ================================================ */
    var priceEl = mainSection.querySelector('[class*="ai-product-details__price-"]');
    var priceText = priceEl ? priceEl.textContent.trim() : '';

    var stickyBar = document.createElement('div');
    stickyBar.className = 'if-sticky-atc';
    stickyBar.id = 'if-sticky-atc';
    stickyBar.innerHTML = [
      '<div class="if-sticky-atc__info">',
      '  <p class="if-sticky-atc__title">' + productTitle + '</p>',
      '  <p class="if-sticky-atc__price">' + priceText + '</p>',
      '</div>',
      '<button class="if-sticky-atc__btn" type="button">Add to Cart</button>'
    ].join('');
    document.body.appendChild(stickyBar);

    var stickyBtn = stickyBar.querySelector('.if-sticky-atc__btn');
    if (stickyBtn && atcBtn) {
      stickyBtn.addEventListener('click', function() { atcBtn.click(); });
    }

    if (atcBtn) {
      var stickyObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('if-sticky-atc--visible');
          } else {
            stickyBar.classList.add('if-sticky-atc--visible');
          }
        });
      }, { threshold: 0 });
      stickyObserver.observe(atcBtn);
    }

    /* ================================================
       7-DAY JOURNEY
       ================================================ */
    var journeyHTML = [
      '<div class="journey-section" id="artisan-journey">',
      '  <p class="journey-section__eyebrow">The Making</p>',
      '  <h2 class="journey-section__title">The 7-Day Journey of Your Textile</h2>',
      '  <p class="journey-section__subtitle">Every piece travels through the hands of master artisans in Jaipur, following a centuries-old process that cannot be rushed.</p>',
      '  <div class="journey-section__grid">',
      '    <div class="journey-step">',
      '      <div class="journey-step__number">01</div>',
      '      <svg class="journey-step__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>',
      '      <p class="journey-step__label">Hand-Carved Blocks</p>',
      '      <p class="journey-step__desc">Teak wood blocks are hand-carved by master block makers, each taking 2\u20133 days to complete.</p>',
      '    </div>',
      '    <div class="journey-step">',
      '      <div class="journey-step__number">02</div>',
      '      <svg class="journey-step__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>',
      '      <p class="journey-step__label">Natural Dye Mixing</p>',
      '      <p class="journey-step__desc">Dyes are prepared from natural sources\u2014indigo plants, pomegranate rinds, and mineral pigments.</p>',
      '    </div>',
      '    <div class="journey-step">',
      '      <div class="journey-step__number">03</div>',
      '      <svg class="journey-step__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>',
      '      <p class="journey-step__label">Block Printing</p>',
      '      <p class="journey-step__desc">Each motif is stamped by hand, one impression at a time, creating the organic variation that defines authenticity.</p>',
      '    </div>',
      '    <div class="journey-step">',
      '      <div class="journey-step__number">04</div>',
      '      <svg class="journey-step__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="4"/><path d="M12 2v2m0 16v2m-8-10h2m16 0h2m-3.3-6.7l-1.4 1.4M6.7 17.3l-1.4 1.4M17.3 17.3l1.4 1.4M6.7 6.7L5.3 5.3"/></svg>',
      '      <p class="journey-step__label">Sun-Dried & Finished</p>',
      '      <p class="journey-step__desc">Fabrics are washed and sun-dried in the Rajasthani sun, then hand-quilted with fine cotton thread.</p>',
      '    </div>',
      '  </div>',
      '</div>'
    ].join('\n');

    /* ================================================
       PDP ACCORDIONS
       ================================================ */
    var accordionsHTML = [
      '<div class="pdp-accordions" id="pdp-details">',
      '  <details class="pdp-accordion">',
      '    <summary>Product Details & Dimensions</summary>',
      '    <div class="pdp-accordion__content">',
      '      <p><strong>Fabric:</strong> 100% organic cotton, hand-block printed with natural dyes.</p>',
      '      <p><strong>Construction:</strong> Three layers of muslin hand-stitched together with fine cotton thread.</p>',
      '      <p><strong>Weight:</strong> Lightweight yet warm \u2014 perfect as a year-round coverlet.</p>',
      '      <ul>',
      '        <li>Twin: 60\u2033 \u00d7 90\u2033 (152 \u00d7 228 cm)</li>',
      '        <li>Queen: 90\u2033 \u00d7 108\u2033 (228 \u00d7 274 cm)</li>',
      '        <li>King: 108\u2033 \u00d7 108\u2033 (274 \u00d7 274 cm)</li>',
      '      </ul>',
      '    </div>',
      '  </details>',
      '  <details class="pdp-accordion">',
      '    <summary>Care Instructions</summary>',
      '    <div class="pdp-accordion__content">',
      '      <p>Your textile is designed to grow softer and more beautiful with every wash.</p>',
      '      <ul>',
      '        <li>Machine wash cold on a gentle cycle with mild detergent.</li>',
      '        <li>Wash separately for the first 2\u20133 washes to allow any excess dye to release.</li>',
      '        <li>Tumble dry low or, for best results, line dry in the sun.</li>',
      '        <li>Avoid bleach or harsh chemicals.</li>',
      '        <li>Iron on a medium setting if desired.</li>',
      '      </ul>',
      '      <p>Sun-drying is the traditional method and helps naturally brighten the fabric.</p>',
      '    </div>',
      '  </details>',
      '  <details class="pdp-accordion">',
      '    <summary>The Concierge Promise</summary>',
      '    <div class="pdp-accordion__content">',
      '      <p><strong>Free Shipping</strong> on all orders over $150 \u2014 delivered via DHL/FedEx with full tracking.</p>',
      '      <p><strong>Duties Included:</strong> We ship DDP to the USA, UK, Canada, and EU. The price you see is the price you pay.</p>',
      '      <p><strong>30-Day Returns:</strong> Not in love? Return any unused, unwashed item within 30 days for a full refund.</p>',
      '      <p><strong>Gift Ready:</strong> Every order arrives in our signature plastic-free packaging \u2014 folded in glassine paper, secured with a cotton belly band, and placed in a reusable cotton tote.</p>',
      '    </div>',
      '  </details>',
      '</div>'
    ].join('\n');

    /* ================================================
       SOCIAL PROOF — "Loved by You"
       ================================================ */
    var reviewsHTML = [
      '<div class="reviews-section" id="loved-by-you">',
      '  <div id="customer-reviews" style="position:relative;top:-80px;pointer-events:none;"></div>',
      '  <h2 class="reviews-section__title">Loved by You</h2>',
      '  <div class="reviews-section__grid">',
      '    <div class="reviews-section__card">',
      '      <div class="reviews-section__stars">\u2605\u2605\u2605\u2605\u2605</div>',
      '      <p class="reviews-section__text">\u201CMy first order and truly impressed by product quality and unique handwork. Product is exactly how described and shown on website which is rare to find. Highly recommended and will definitely buy again.\u201D</p>',
      '      <p class="reviews-section__author">Verified Google Review</p>',
      '    </div>',
      '    <div class="reviews-section__card">',
      '      <div class="reviews-section__stars">\u2605\u2605\u2605\u2605\u2605</div>',
      '      <p class="reviews-section__text">\u201CLove the quality. Highly recommend it.\u201D</p>',
      '      <p class="reviews-section__author">Verified Google Review</p>',
      '    </div>',
      '  </div>',
      '</div>'
    ].join('\n');

    /* ================================================
       INJECT SECTIONS
       ================================================ */
    if (insertParent && insertBeforeTarget) {
      var journeyWrapper = document.createElement('div');
      journeyWrapper.className = 'shopify-section indigo-injected';
      journeyWrapper.style.borderTop = '1px solid #E8E2D8';
      journeyWrapper.innerHTML = journeyHTML;
      insertParent.insertBefore(journeyWrapper, insertBeforeTarget);

      var accordionWrapper = document.createElement('div');
      accordionWrapper.className = 'shopify-section indigo-injected';
      accordionWrapper.innerHTML = accordionsHTML;
      insertParent.insertBefore(accordionWrapper, insertBeforeTarget);
    } else if (mainParent) {
      var journeyWrapper2 = document.createElement('div');
      journeyWrapper2.className = 'shopify-section indigo-injected';
      journeyWrapper2.style.borderTop = '1px solid #E8E2D8';
      journeyWrapper2.innerHTML = journeyHTML;
      mainParent.after(journeyWrapper2);

      var accordionWrapper2 = document.createElement('div');
      accordionWrapper2.className = 'shopify-section indigo-injected';
      accordionWrapper2.innerHTML = accordionsHTML;
      journeyWrapper2.after(accordionWrapper2);
    }

    var lastInjected = document.querySelectorAll('.indigo-injected');
    var insertReviewsAfter = recommendations
      ? (recommendations.closest('.shopify-section') || recommendations)
      : (lastInjected.length ? lastInjected[lastInjected.length - 1] : null);

    if (insertReviewsAfter) {
      var reviewsWrapper = document.createElement('div');
      reviewsWrapper.className = 'shopify-section indigo-injected';
      reviewsWrapper.style.cssText = 'border-top: 1px solid #E8E2D8;';
      reviewsWrapper.innerHTML = reviewsHTML;
      insertReviewsAfter.after(reviewsWrapper);
    } else if (mainParent) {
      var fallbackTarget = document.querySelectorAll('.indigo-injected');
      var lastFallback = fallbackTarget.length ? fallbackTarget[fallbackTarget.length - 1] : mainParent;
      var reviewsWrapper2 = document.createElement('div');
      reviewsWrapper2.className = 'shopify-section indigo-injected';
      reviewsWrapper2.style.cssText = 'border-top: 1px solid #E8E2D8;';
      reviewsWrapper2.innerHTML = reviewsHTML;
      lastFallback.after(reviewsWrapper2);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIndigoFable);
  } else {
    initIndigoFable();
  }
})();
